export const USE_INFO_USER = 'USE_INFO_USER';

export const LIST_URL_NOT_REDIRECT_WHEN_403 = ['/admin/candidate-detail/:candidateId'];
